import { render, staticRenderFns } from "./preflightUploadArea.vue?vue&type=template&id=bc7e00ba&scoped=true&"
import script from "./preflightUploadArea.vue?vue&type=script&lang=js&"
export * from "./preflightUploadArea.vue?vue&type=script&lang=js&"
import style0 from "./preflightUploadArea.vue?vue&type=style&index=0&id=bc7e00ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e00ba",
  null
  
)

export default component.exports